export default __webpack_public_path__ + "static/media/fauna-mobile-chart.af759eb7.png";